const XIVADO_APP_TOKENS = process.env.REACT_APP_XIVADO_APP_TOKENS.split(',');

/**
 * Determines if the application id is one that requires a redirect to login success on login
 * @param applicationConfig
 * @returns {boolean}
 */
const isBevy = (applicationConfig) => {
  const token = applicationConfig?.token ?? '';
  return token.toLowerCase() === 'ho1rwfrok';
};

const isBrowser = () => typeof window !== 'undefined';

const isXivado = (application) => {
  return XIVADO_APP_TOKENS.includes(application);
};

const hasText = (value) => !(value === undefined || value.toString() === '');

function hasValidProps(...args) {
  return args.every((e) => hasText(e));
}

export { hasValidProps, isBevy, isBrowser, isXivado };
